export const TourbookAction = {
    LOAD: 'LOAD',
    RELEASE: 'RELEASE',
    UPDATE: 'UPDATE',
};

export const TourbookMutation = {
    REQUEST: 'REQUEST',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    RELEASE_SUCCESS: 'RELEASE_SUCCESS',
    UPDATE_SUCCESS: 'UPDATE_SUCCESS',
};
